import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { KbFileService } from 'src/app/services/feature/myacc-popup-fileService/kbfileService.service';

@Injectable()
export class KbReturnRequestForm {
    constructor(private http: HttpClient, private occService: OccEndpointsService, private kbFileService: KbFileService) { }
    getPdf(claimNumber, CustomerPartNumber, formData) {
        return this.http.post(
            this.occService.buildUrl(
                `mywarranty/getinspectionreportpdf?claimNumber=${claimNumber}&CustomerPartNumber=${CustomerPartNumber}&defaultSoldTo=${formData.defaultSoldTo}`
            ),
            formData
        );
    }
    getSubmitWarranty() {
        return this.http.get(this.occService.buildUrl('mywarranty/getreturnform'));
    }

    submitWarrantyForReview(data) {
        return this.http.post(this.occService.buildUrl('mywarranty/returnfinalreview'), data);
    }

    finalSubmitWarranty(data) {
        return this.http.post(this.occService.buildUrl('mywarranty/returnsubmit'), data);
    }

    getProductForCustomPart(code: string) {
        return this.http.get(this.occService.buildUrl('mywarranty/getProductForCustomPartNA'), {
            params: {
                code,
            },
        });
    }
}


// soldTo: 0001021230_0313_30_00
// email: richa.cap01@gmail.com
// phoneNumber:
// email1:
// email2:
// PONumber: 1111111111
// partRows: 0
// partInfoDataList[0].customerPartNumber: 800516
// partInfoDataList[0].entryNumber: 0
// partInfoDataList[0].partNumber: 800516
// partInfoDataList[0].quantity: 345
// partInfoDataList[0].returnRequestType: WrongCustomer
// partInfoDataList[0].natureOfDefect: fdghj
// finalSubmit:
// CSRFToken: 0dc98aa6-82d1-4624-b378-1dccec10840b
